export default __webpack_public_path__ + "static/media/About.5b486c35.png";